module.exports = __webpack_public_path__ + "assets/media/vk.7487d391.svg";